import { gql } from '@lcs/shared/api';

export const getCallSegmentsAndRecordings = gql`
   query GetCallSegmentsAndRecordings($id: UInt!) {
      callDetail(id: $id) {
         callDetailId
         account {
            accountId
            name
         }
         callDirectionTypeId
         callerChannelId
         serverName
         sipCallId
         providerId
         sourceProviderId
         destinationProviderId
         sourceIpAddress
         destinationIpAddress
         stirShakenVerification
         stirShakenAttest
         stirShakenToken
         originalDestinationNumber
         destinationNumber
         sourceExtension {
            extensionId
            number
            name
         }
         sourceNumber
         destinationExtension {
            extensionId
            number
            name
         }
         startTime
         endTime
         callSegmentsConnection {
            items {
               callSegmentId
               callDetailId
               sourceExtensionId
               extensionId
               sourceExtension {
                  extensionId
                  extensionType {
                     name
                  }
                  name
                  number
               }
               extension {
                  extensionId
                  extensionType {
                     name
                  }
                  name
                  number
               }
               startDate
               endDate
               sequence
               duration
            }
         }
         queueHistoryCallDetailsConnection {
            items {
               queueHistory {
                  queueHistoryId
                  callDetailId
                  queueExtensionId
                  enqueuedDateTime
                  callbackCompleteDateTime
                  callbackRequestDateTime
                  callDispositionId
                  queueAgentDialsConnection {
                     items {
                        queueAgentDialId
                        queueHistoryId
                        agentExtension {
                           extensionId
                           name
                           number
                        }
                        dialStartTime
                        dialEndTime
                        dialStatus
                     }
                  }
                  queueCallbackDialsConnection {
                     items {
                        queueCallbackDialId
                        dialStartTime
                        dialEndTime
                     }
                  }
                  queueHistoryCallDetailsConnection {
                     items {
                        queueHistoryCallDetailId
                        callDetailId
                     }
                  }
               }
            }
         }
         callRecording {
            file {
               fileId
               fileToken
               fileName
               displayName
            }
         }
      }
   }
`;

export const getRelatedCallDetail = gql`
   query GetRelatedCallDetail($id: UInt!) {
      callDetail(id: $id) {
         callDetailId
         callDirectionTypeId
         endTime
         serverName
         sipCallId
         providerId
         sourceIpAddress
         destinationIpAddress
         stirShakenVerification
         stirShakenAttest
         stirShakenToken
         startTime
         callDirectionTypeId
         originalDestinationNumber
         sourceExtension {
            extensionId
            number
            name
         }
         sourceNumber
         destinationExtension {
            extensionId
            number
            name
         }
         destinationNumber
         sourceExtensionId
         callSegmentsConnection {
            items {
               callSegmentId
               callDetailId
               sourceExtensionId
               extensionId
               sourceExtension {
                  extensionId
                  extensionType {
                     name
                  }
                  name
                  number
               }
               extension {
                  extensionId
                  extensionType {
                     name
                  }
                  name
                  number
               }
               startDate
               endDate
               sequence
               duration
            }
         }
         queueHistoryCallDetailsConnection {
            items {
               callDetailId
               queueHistory {
                  queueHistoryId
                  queueExtensionId
                  enqueuedDateTime
                  callbackCompleteDateTime
                  callbackRequestDateTime
                  callDispositionId
                  queueAgentDialsConnection {
                     items {
                        queueAgentDialId
                        queueHistoryId
                        agentExtension {
                           extensionId
                           name
                           number
                        }
                        dialStartTime
                        dialEndTime
                        dialStatus
                     }
                  }
                  queueCallbackDialsConnection {
                     items {
                        queueCallbackDialId
                        dialStartTime
                        dialEndTime
                     }
                  }
               }
            }
         }
      }
   }
`;
